export default __webpack_public_path__ + "static/media/diners_club.bf6d630c.svg";